import { R2_CONFIG } from '@core/r2.config'
import {
  confirmBrandingLogo,
  getCurrentBranding,
  resolveTenant,
  updateCurrentBranding,
} from '@shared/api/generated/tenants/tenants'
import { deleteFile } from '@shared/api/generated/uploads/uploads'
import { rollbackUploadedFiles, uploadPendingFile } from '@shared/lib/upload/upload-service'
import type {
  ApiEnvelope,
  TenantBrandingResponse,
  UpdateTenantBrandingDto,
} from '../types/branding.types'

function normalizePublicUrl(url: string) {
  return url.replace(/\/+$/, '')
}

export function buildR2FileUrl(fileKey: string) {
  return `${normalizePublicUrl(R2_CONFIG.publicUrl)}/${fileKey.replace(/^\/+/, '')}`
}

export function extractManagedFileKey(fileUrl?: string | null) {
  if (!fileUrl) {
    return undefined
  }

  const publicUrl = normalizePublicUrl(R2_CONFIG.publicUrl)
  if (!fileUrl.startsWith(`${publicUrl}/`)) {
    return undefined
  }

  return fileUrl.slice(publicUrl.length + 1)
}

export async function resolveTenantBranding(host?: string) {
  const response = await resolveTenant(host ? { host } : undefined)
  return response as ApiEnvelope<TenantBrandingResponse>
}

export async function getCurrentTenantBranding() {
  return getCurrentBranding() as Promise<ApiEnvelope<TenantBrandingResponse>>
}

export async function updateCurrentTenantBranding(data: UpdateTenantBrandingDto) {
  return updateCurrentBranding(data) as Promise<ApiEnvelope<TenantBrandingResponse>>
}

export async function uploadBrandingLogo(file: File) {
  const uploaded = await uploadPendingFile(file)
  try {
    const response = await confirmBrandingLogo({
      fileKey: uploaded.fileKey,
      contentType: uploaded.contentType,
      fileSize: uploaded.fileSize,
      sha256: uploaded.sha256,
    })
    if (!response.data?.logoUrl) throw new Error('Não foi possível confirmar o logo enviado.')
    return { fileKey: uploaded.fileKey, logoUrl: response.data.logoUrl }
  } catch (error) {
    await rollbackUploadedFiles([uploaded])
    throw error
  }
}

export async function deleteBrandingLogo(fileUrl?: string | null) {
  const fileKey = extractManagedFileKey(fileUrl)
  if (!fileKey) {
    return
  }

  await deleteFile(fileKey)
}
